import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const ChangePasswordPage = () => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [logoMessage, setLogoMessage] = useState('FBAJANS İLE KOLAY E-TİCARET'); // Logo mesajı state'i
  const navigate = useNavigate();
  const location = useLocation();

  // URL state'ten forced ve message al
  const isForced = location.state?.forced || false;
  const forceMessage = location.state?.message || '';

  // Logo mesajını backend'den çek
  useEffect(() => {
    const fetchLogoMessage = async () => {
      try {
        const response = await fetch('/api/admin/settings');
        const data = await response.json();
        if (data.success && data.data.logo_message) {
          setLogoMessage(data.data.logo_message);
        }
      } catch (error) {
        console.error('Logo mesajı çekilemedi:', error);
      }
    };

    fetchLogoMessage();
  }, []);

  useEffect(() => {
    // Title ayarla
    document.title = 'FBAJANS WhatsApp Business - Şifre Değiştir';
    
    // Auth kontrolü
    if (!sessionStorage.getItem('authToken')) {
      navigate('/');
      return;
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Validasyon
    if (!formData.currentPassword) {
      setError('Mevcut şifrenizi girmeniz gerekiyor!');
      setLoading(false);
      return;
    }

    if (!formData.newPassword) {
      setError('Yeni şifrenizi girmeniz gerekiyor!');
      setLoading(false);
      return;
    }

    if (formData.newPassword.length < 6) {
      setError('Yeni şifre en az 6 karakter olmalıdır!');
      setLoading(false);
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError('Yeni şifreler eşleşmiyor! Lütfen aynı şifreyi tekrar girin.');
      setLoading(false);
      return;
    }

    if (formData.currentPassword === formData.newPassword) {
      setError('Yeni şifre mevcut şifreden farklı olmalıdır!');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch('https://panel.fbajans.com/api/auth/change_password.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('authToken')}`
        },
        body: JSON.stringify({
                     username: sessionStorage.getItem('username'),
          current_password: formData.currentPassword,
          new_password: formData.newPassword
        })
      });

      const data = await response.json();

      if (data.status === 'success') {
        setSuccess('Şifreniz başarıyla değiştirildi! 3 saniye sonra yönlendirileceksiniz...');
        
                 setTimeout(() => {
           const userRole = sessionStorage.getItem('userRole');
           if (userRole === 'admin') {
             navigate('/admin');
           } else {
             navigate('/dashboard');
           }
         }, 3000);
      } else {
        setError(data.message || 'Şifre değiştirme başarısız!');
      }
    } catch (error) {
      console.error('Password change error:', error);
      setError('Sunucu hatası. Lütfen daha sonra tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (isForced) {
      // Forced değişimde iptal edemez, logout yap
      localStorage.clear();
      navigate('/');
    } else {
      // Normal değişimde geri dön - kullanıcı rolünü doğru kontrol et
             const userRole = sessionStorage.getItem('userRole');
       const username = sessionStorage.getItem('username');
       const authToken = sessionStorage.getItem('authToken');
      
      console.log('🔍 Debug bilgileri:');
      console.log('  - userRole:', userRole);
      console.log('  - username:', username);
      console.log('  - authToken:', authToken);
      console.log('  - localStorage tüm içerik:', Object.keys(localStorage));
      
      if (userRole === 'admin') {
        console.log('👑 Admin paneline yönlendiriliyor...');
        navigate('/admin');
      } else {
        console.log('👤 Kullanıcı paneline yönlendiriliyor...');
        console.log('⚠️ Beklenen: admin, Gerçek:', userRole);
        navigate('/dashboard');
      }
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '450px',
        textAlign: 'center'
      }}>
        {/* Header */}
        <div style={{ marginBottom: '30px' }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '10px'
          }}>
            <i className="fas fa-key" style={{ fontSize: '48px', color: '#667eea' }}></i>
          </div>
          <h1 style={{
            margin: '0 0 5px',
            color: '#333',
            fontSize: '28px',
            fontWeight: 'bold',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            FBAJANS WhatsApp Business
          </h1>
          <p style={{
            margin: '0 0 15px',
            color: '#666',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            Şifre Değiştir
          </p>
          {isForced && (
            <div style={{
              background: '#fff3cd',
              color: '#856404',
              padding: '15px',
              borderRadius: '10px',
              fontSize: '14px',
              border: '1px solid #ffeaa7',
              marginTop: '15px'
            }}>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
            {forceMessage}
            </div>
          )}
        </div>

        {/* Success Message */}
        {success && (
          <div style={{
            background: '#d4edda',
            color: '#155724',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
            border: '1px solid #c3e6cb'
          }}>
            <i className="fas fa-check-circle" style={{ marginRight: '8px' }}></i>
            {success}
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div style={{
            background: '#fee',
            color: '#c53030',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
            border: '1px solid #fed7d7'
          }}>
            <i className="fas fa-exclamation-circle" style={{ marginRight: '8px' }}></i>
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="password"
              name="currentPassword"
              placeholder="Mevcut Şifre"
              value={formData.currentPassword}
              onChange={handleInputChange}
              required
              style={{
                width: '100%',
                padding: '15px',
                fontSize: '16px',
                border: '2px solid #e2e8f0',
                borderRadius: '10px',
                outline: 'none',
                transition: 'border-color 0.3s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#e74c3c'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <input
              type="password"
              name="newPassword"
              placeholder="Yeni Şifre (min 6 karakter)"
              value={formData.newPassword}
              onChange={handleInputChange}
              required
              minLength="6"
              style={{
                width: '100%',
                padding: '15px',
                fontSize: '16px',
                border: '2px solid #e2e8f0',
                borderRadius: '10px',
                outline: 'none',
                transition: 'border-color 0.3s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#e74c3c'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>

          <div style={{ marginBottom: '25px' }}>
            <input
              type="password"
              name="confirmPassword"
              placeholder="Yeni Şifre (Tekrar)"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
              style={{
                width: '100%',
                padding: '15px',
                fontSize: '16px',
                border: '2px solid #e2e8f0',
                borderRadius: '10px',
                outline: 'none',
                transition: 'border-color 0.3s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#e74c3c'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              type="submit"
              disabled={loading}
              style={{
                flex: 1,
                padding: '15px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: 'white',
                background: loading ? '#a0aec0' : 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
                border: 'none',
                borderRadius: '10px',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s'
              }}
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                  Değiştiriliyor...
                </>
              ) : (
                <>
                  <i className="fas fa-check" style={{ marginRight: '8px' }}></i>
                  Şifreyi Değiştir
                </>
              )}
            </button>

            {!isForced && (
              <button
                type="button"
                onClick={handleCancel}
                disabled={loading}
                style={{
                  flex: 1,
                  padding: '15px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  color: '#666',
                  background: '#f8f9fa',
                  border: '2px solid #e2e8f0',
                  borderRadius: '10px',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s'
                }}
              >
                <i className="fas fa-times" style={{ marginRight: '8px' }}></i>
                İptal
              </button>
            )}
          </div>
        </form>

        {isForced && (
          <div style={{
            marginTop: '20px',
            padding: '15px',
            background: '#f8f9fa',
            borderRadius: '10px',
            fontSize: '12px',
            color: '#666'
          }}>
            <p style={{ margin: 0 }}>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
              Güvenlik gereği bu adım zorunludur. İptal etmek istiyorsanız{' '}
              <button
                onClick={handleCancel}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#e74c3c',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                çıkış yapabilirsiniz
              </button>
            </p>
          </div>
        )}

        {/* Info */}
        <div style={{
          marginTop: '25px',
          padding: '15px',
          background: '#f8f9fa',
          borderRadius: '10px',
          fontSize: '14px',
          color: '#666'
        }}>
          <h4 style={{ margin: '0 0 10px 0' }}>
            <i className="fas fa-lightbulb" style={{ marginRight: '8px' }}></i>
            Güvenli Şifre Önerileri:
          </h4>
          <ul style={{ textAlign: 'left', margin: 0, paddingLeft: '20px' }}>
            <li>En az 6 karakter kullanın</li>
            <li>Büyük ve küçük harf karışımı</li>
            <li>Rakam ve özel karakter ekleyin</li>
            <li>Tahmin edilmesi kolay bilgiler kullanmayın</li>
          </ul>
        </div>

        {/* Footer */}
        <div style={{
          marginTop: '25px',
          padding: '15px 0',
          borderTop: '1px solid #e2e8f0',
          color: '#718096',
          fontSize: '12px'
        }}>
          © 2025 FBAJANS WhatsApp Business - Tüm hakları saklıdır
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordPage; 